/**
 * AdminComingSoon — restrained "Coming soon" placeholder for the
 * Phase 1 sidebar stubs (Dashboard, Bookings, Analytics, PooPartners).
 *
 * Each stub passes its own title + when-coming copy so the placeholder
 * page reads as an honest commitment rather than a generic "todo".
 * Slate text on the page bg — no oversized hero, no marketing pitch.
 */
import React from "react";
import { Construction } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminComingSoon({ title, eta = "Coming soon" }) {
  return (
    <div
      className="mx-auto max-w-xl py-24 text-center text-pp-text"
      data-testid="admin-coming-soon"
    >
      <Construction
        className="mx-auto h-10 w-10 text-pp-orange"
        aria-hidden="true"
      />
      <h2
        className="mt-4 font-heading text-2xl font-semibold"
        data-testid="admin-coming-soon-title"
      >
        {title}
      </h2>
      <p
        className="mt-2 text-sm text-pp-text-muted"
        data-testid="admin-coming-soon-eta"
      >
        {eta}
      </p>
      <Link
        to="/admin/accounts"
        className="mt-6 inline-flex items-center gap-2 rounded-full border border-pp-border bg-pp-surface px-5 py-2 text-sm font-semibold text-pp-text hover:bg-pp-surface2 transition-colors"
        data-testid="admin-coming-soon-back"
      >
        Back to Accounts
      </Link>
    </div>
  );
}
